import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuControlsOption} from '@Components/contextual-menu/components/contextual-menu-controls-option';
import styles from './item-flip-and-stretch-options.module.scss';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromActiveItem} from '@Hooks/poster-editor/useGetKeyFromActiveItem';

enum PosterItemFlipAndStretchOptions {
  FLIP_VERTICAL = 'flip-vertical',
  FLIP_HORIZONTAL = 'flip-horizontal',
  STRETCH_VERTICAL = 'stretch-vertical',
  STRETCH_HORIZONTAL = 'stretch-horizontal',
}

export function ItemFlipAndStretchOptions(): ReactElement {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const isLocked = useGetKeyFromActiveItem('lockMovementX');

  const onFlipVerical = (): void => {
    activeItem?.flipItemVertically();
  };
  const onFlipHorizontal = (): void => {
    activeItem?.flipItemHorizontally();
  };
  const onStretchVertical = (): void => {
    void activeItem?.stretchToCanvasVertically();
  };
  const onStretchHorizontal = (): void => {
    void activeItem?.stretchToCanvasHorizontally();
  };

  const onClickHandler = (clickedId: PosterItemFlipAndStretchOptions): void => {
    switch (clickedId) {
      case PosterItemFlipAndStretchOptions.FLIP_VERTICAL: {
        onFlipVerical();
        return;
      }
      case PosterItemFlipAndStretchOptions.FLIP_HORIZONTAL: {
        onFlipHorizontal();
        return;
      }
      case PosterItemFlipAndStretchOptions.STRETCH_VERTICAL: {
        onStretchVertical();
        return;
      }
      case PosterItemFlipAndStretchOptions.STRETCH_HORIZONTAL: {
        onStretchHorizontal();
        return;
      }
      default:
        throw new Error('unhandled item positioning option');
    }
  };
  return (
    <ContextualMenuControlsOption
      id="item-flip-and-stretch-options"
      onClick={onClickHandler}
      wrapItems
      isCenterAligned
      containerClassName={`${styles.itemContainer} spacing-m-t-2`}
      data={[
        {
          id: PosterItemFlipAndStretchOptions.FLIP_VERTICAL,
          icon: 'icon-flip-vertical',
          text: window.i18next.t('pmwjs_flip_vertical'),
          wrapText: true,
          className: styles.items,
          disabled: isLocked,
        },
        {
          id: PosterItemFlipAndStretchOptions.FLIP_HORIZONTAL,
          icon: 'icon-flip-horizontal',
          text: window.i18next.t('pmwjs_flip_horizontal'),
          wrapText: true,
          className: styles.items,
          disabled: isLocked,
        },
        {
          id: PosterItemFlipAndStretchOptions.STRETCH_VERTICAL,
          icon: 'icon-stretch-vertical',
          text: window.i18next.t('pmwjs_stretch_vertical'),
          wrapText: true,
          className: styles.items,
          disabled: isLocked,
        },
        {
          id: PosterItemFlipAndStretchOptions.STRETCH_HORIZONTAL,
          icon: 'icon-stretch-horizontal',
          text: window.i18next.t('pmwjs_stretch_horizontal'),
          wrapText: true,
          className: styles.items,
          disabled: isLocked,
        },
      ]}
    />
  );
}
